import { SourceBasedExpression } from '../Expression.js';
export class ToUpperCaseExpression extends SourceBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource().evaluate(visitor, localVariables);
        return String(source).toUpperCase();
    }
}
//# sourceMappingURL=ToUpperCaseExpression.js.map